
import Vue from 'vue';
import { QuestionModel, ReplyModel, SolutionModel } from '@descomplica/dex-models';
import StatusCircle from './StatusCircle.vue';
import RevisionQuestion from './RevisionQuestion.vue';
import RevisionQuestionSolution from './RevisionQuestionSolution.vue';
import Constants from '../settings/ui';

interface Data {
  currentQuestionIndex: number;
}

export default Vue.extend({
  components: {
    StatusCircle,
    RevisionQuestion,
    RevisionQuestionSolution,
  },
  props: {
    questions: {
      type: Array as Vue.PropType<QuestionModel[]>,
      required: true,
    },
  },
  data(): Data {
    return {
      currentQuestionIndex: 0,
    };
  },
  computed: {
    currentQuestion(): QuestionModel {
      return this.questions[this.currentQuestionIndex];
    },
    userQuestionReply(): ReplyModel | null {
      return this.getUserQuestionReply(this.currentQuestion);
    },
    professorSolution(): SolutionModel | null {
      return (
        this.currentQuestion.solutions.find((solution: SolutionModel) => solution.user.isAdmin()) ||
        null
      );
    },
    statusCircleColor(): String {
      return Constants.colorPalette.white;
    },
  },
  methods: {
    isQuestionCorrect(question: QuestionModel): Boolean {
      const reply = this.getUserQuestionReply(question);
      return !!reply && !!reply.isCorrect();
    },
    getUserQuestionReply(question: QuestionModel): ReplyModel | null {
      if (!question) return null;

      const replies =
        question.replies &&
        question.replies.filter((reply: ReplyModel) => reply.questionId === question.id);

      if (!replies || !replies.length) {
        return null;
      }

      const mostRecentReply = replies.reduce((reply1: ReplyModel, reply2: ReplyModel) => {
        const date1 = new Date(reply1.createdAt as string);
        const date2 = new Date(reply2.createdAt as string);
        return date1.getTime() > date2.getTime() ? reply1 : reply2;
      });

      return mostRecentReply;
    },
    goToQuestion(index: number): void {
      this.currentQuestionIndex = index;
    },
  },
});
